/*
*   Custom module to control "order instructions" step on the checkout page
*
*/
define('modules/Checkout/OnePageCheckout.OrderInstructions',[
    'jquery',
    'lodash',
    'global/all'
], function ($, _, Roc) {
    'use strict';

    var selector = 'textarea[data-roc-action="orderInstructions"]';
    var requestParamKey = 'order-instructions';

    function includeInRequest(processOrderRequest) {
        if (!_.isObject(processOrderRequest)){
            return;
        }

        var value = $.trim($(selector).val());
        if (_.isEmpty(value)) {// exit if there is no matching element on the page
            return;
        }

        if (!_.has(processOrderRequest, 'requestCustomFields')) {
            processOrderRequest.requestCustomFields = {};
        }

        processOrderRequest.requestCustomFields[requestParamKey] = value;
    }

    var OrderInstructions = {
        includeInRequest: includeInRequest
    };

    Roc.Logger.debug('OnePageCeckout.OrderInstructions.js Loaded:', OrderInstructions);

    return OrderInstructions;

});
